import React from 'react';

import { FormField, Label } from '@zillow/constellation';

import type { Section } from '../../../models';
import { METHAMPHETAMINE } from '../../../constants';
import YesAndNo from '../../../../shared/components/Widgets/YesAndNo';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function Methamphetamine_v2({ section, setSectionValues }: Props) {
  function onNoKnowledge(): void {
    setSectionValues({
      [METHAMPHETAMINE.FIELD_NAME.KNOWLEDGE]: false,
    });
  }

  function onYesKnowledge(): void {
    setSectionValues({
      [METHAMPHETAMINE.FIELD_NAME.KNOWLEDGE]: true,
    });
  }

  return (
    <FormField
      label={
        <Label size="lg">
          Do you have knowledge if the premises were used as a site for methamphetamine production?
        </Label>
      }
      control={
        <YesAndNo
          yesHandler={onYesKnowledge}
          noHandler={onNoKnowledge}
          yesActive={section.getFieldValue(METHAMPHETAMINE.FIELD_NAME.KNOWLEDGE)}
        />
      }
    />
  );
}

Methamphetamine_v2.description = 'Asks whether or not the landlord has knowledge of meth production';

export default Methamphetamine_v2;
